module.exports = __webpack_public_path__ + "img/azimut.8ac9b4a2.png";